// src/components/ModeloDestacado/ModeloDestacadoCard.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import styles from './ModeloDestacadoCard.module.scss'

const ModeloDestacadoCard = ({ modelo, selectedLineaSlug, slug, imagenCard }) => {
  const imgSrc = imagenCard || '/images/General/image_not_available.webp'

  return (
    <article
      className={styles.card}
      tabIndex="0"
      aria-labelledby={`mdl-title-${slug}`}
    >
      <div className={styles.imageWrapper}>
        <img
          src={imgSrc}
          alt={`Imagen del modelo ${modelo}`}
        />
      </div>
      <div className={styles.header}>
        <h4 id={`mdl-title-${slug}`} className={styles.modelName}>
          {modelo}
        </h4>
      </div>
      <div className={styles.buttonWrapper}>
        <Link
          to={`/productos/${selectedLineaSlug}/${slug}`}
          className={styles.button}
        >
          Consultar
        </Link>
      </div>
    </article>
  )
}

export default ModeloDestacadoCard